
import "./ProfessionalDetails.scss";

import {
  I18_TRANSLATION_COMMON,
  NUMBER_CONSTANTS,
  STORAGE_KEYS,
} from "../../../../Utilities/Constants/Constants";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";

import { GetSessionStorageData } from "../../../../Services/Helpers/Helper";
import Tutor from "./Tutor/Tutor";
import Recreational from "./Recreational/Recreational";
import ReacreationalCamp from "./ReacreationalCamp/RecreationalCamp";
import Expert from "./Expert/Expert";

const ProfessionalDetails = (props: any) => {
  const [ userType , setuserType]:any= useState("");
  useEffect(()=>{
    setuserType(GetSessionStorageData(STORAGE_KEYS.ROLE));
   
   },[]);
  return (
    <>
      {userType===`${NUMBER_CONSTANTS.FOUR}` && <Tutor setActiveStatus={(state:any)=>{
        props.activeStatus(state);
      }}/>}
      {userType===`${NUMBER_CONSTANTS.NINE}`&& <Recreational setActiveStatus={(state:any)=>{
        props.activeStatus(state);
      }}/>}
      {userType===`${NUMBER_CONSTANTS.FIVE}`  && <ReacreationalCamp setActiveStatus={(state:any)=>{
        props.activeStatus(state);
      }}/>}
      {userType===`${NUMBER_CONSTANTS.THREE}`  && <Expert setActiveStatus={(state:any)=>{
        props.activeStatus(state);
      }}/>}
    </>
  );
};

export default ProfessionalDetails;
